import {RouteInfo} from './sidebar.metadata';

export const ROUTES: RouteInfo[] = [

  /*{
    path: '#',
    title: 'Wallet',
    icon: 'id-contabilita',
    class: 'has-sub',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    committee:['P', 'G','N'],
    permission: ['A', 'C'],
    submenu: [
      {
        path: '/wallet',
        title: 'Pagam./Ricaric',
        icon: 'id-contabilita',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [],
        committee:['P', 'G'],
        permission: ['A', 'C']
      },
      {
        path: '/walletadmin',
        title: 'Pagam./Ricaric',
        icon: 'id-contabilita',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [],
        committee:['N'],
        permission: ['A', 'C']
      },
    ],

  },*/{
    path: '#',
    title: 'Anagrafiche',
    icon: 'id-verifica-off',
    class: 'has-sub',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    committee:['N','R','P','G','A'],
    permission: ['AS', 'C', 'S','AS'],
    submenu:[
      {
        path: '/servizi/affiliazioni/profilo/me',
        title: 'Profilo',
        icon: 'id-verifica-off',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [],
        committee:['A'],
        permission: ['AS', 'C', 'S']
      },{
        path: '/servizi/tesseramento',
        title: 'Tesserati',
        icon: 'id-tesserato',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [],
        committee:['A'],
        permission: ['AS', 'C', 'S']
      },{
        path: '/servizi/affiliazioni',
        title: 'Affiliati',
        icon: 'id-verifica-off',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [],
        committee:['N','R','P','G'],
        permission: ['AS', 'C', 'S']
      },{
        path: '/servizi/tesseramento',
        title: 'Tesserati',
        icon: 'id-tesserato',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [],
        committee:['N','R','P','G'],
        permission: ['AS', 'C', 'S']
      },{
        path: '/utenti',
        title: 'Utenti',
        icon: 'id-utenti',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [],
        committee:['N'],
        permission: ['U']
      },{
        path: '/servizi/disabili',
        title: 'Disabilità',
        icon: 'id-utenti',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [],
        committee:['N'],
        permission: ['T']
      },{
        path: '/servizi/report',
        title: 'Report',
        icon: 'id-utenti',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [],
        committee:['N'],
        permission: ['U']
      }, {
        path: '/impianti-extra',
        title: 'Impianti',
        icon: 'id-utenti',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [],
        committee:['A', 'N'],
        permission: ['AS', 'C', 'S']
      }
    ]
  },
  {
    path: '/wallet',
    title: 'Wallet',
    icon: 'id-contabilita',
    class: '',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: [],
    committee:['P', 'G'],
    permission: ['A', 'C']
  },
  {
    path: '/walletadmin',
    title: 'Wallet',
    icon: 'id-contabilita',
    class: '',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: [],
    committee:['N'],
    permission: ['A', 'C']
  },
  {
    path: '#',
    title: 'Gestione Tessere',
    icon: 'id-tessera',
    class: 'has-sub',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    committee:['N','P','G','A'],
    permission: ['AS', 'C', 'S'],
    submenu:[
      {
        path: '/servizi/tessere',
        title: 'Tessere',
        icon: 'id-tessera',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [],
        committee:['N','P','G','A'],
        permission: ['AS', 'C', 'S']
      },{
        path: '/servizi/interno/interno',
        title: 'Tess Diretto',
        icon: 'id-tesserato',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [],
        committee:['N','R','P'],
        permission: ['AS', 'C', 'S']
      },{
        path: '/servizi/magazzino',
        title: 'Magazzino',
        icon: 'id-tessera',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [],
        committee:['N','P','G','A'],
        permission: ['AS', 'C', 'S']
      }
    ]
  },
  {
    path: '#',
    title: 'Albi',
    icon: 'id-tecnici',
    class: 'has-sub',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    committee:['N','R','P','G'],
    permission: ['T', 'C'],
    submenu: [
      {
        path: '/albo/tecnici',
        title: 'Albo tecnici',
        icon: 'id-tecnici',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [],
        committee:['N','R','P','G'],
        permission: ['T', 'C']
      }, {
        path: '/albo/formatori',
        title: 'Albo formatori',
        icon: 'id-formatori',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [],
        committee:['N','R','P','G'],
        permission: ['T', 'C']
      },{
        path: '/servizi/conversioni',
        title: 'Conversioni',
        icon: 'id-conversioni',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [],
        committee:['N','P','G'],
        permission: ['T', 'C']
      }
    ]
  },
  {
    path: '#',
    title: 'Strutture',
    icon: 'id-comitati',
    class: 'has-sub',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    committee:['N','R','P','A'],
    permission: ['S','AS'],
    submenu: [
      {
      path: '/servizi/gruppi',
      title: 'Gruppi',
      icon: 'id-gruppi',
      class: '',
      badge: '',
      badgeClass: '',
      isExternalLink: false,
      submenu: [],
      committee:['N','G'],
      permission: ['S']
      },{
        path: '/servizi/comitati',
        title: 'Comitati',
        icon: 'id-comitati',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [],
        committee:['N','R','P'],
        permission: ['S']
      }
    ]
  },
  {
    path: '#',
    title: 'Attività',
    icon: 'id-corsi',
    class: 'has-sub',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    committee:['N','P','G','A','R'],
    permission: ['T', 'C','AS'],
    submenu: [
      {
      path: '/servizi/formativa',
      title: 'Att. Formative',
      icon: 'id-corsi',
      class: '',
      badge: '',
      badgeClass: '',
      isExternalLink: false,
      submenu: [],
      committee:['N','P','G','A'],
      permission: ['T', 'C','AS']
    },
      {
        path: '/servizi/didattica',
        title: 'Att. Didattiche',
        icon: 'id-corsi',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [],
        committee:['N','P','G','A'],
        permission: ['T', 'C','AS']
      },
      {
        path: '/servizi/eventi',
        title: 'Att. Sportive',
        icon: 'id-eventi',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [],
        committee:['N','P','G', 'R'],
        permission: ['T', 'C']
      }, {
        path: '/servizi/gare',
        title: 'Gare',
        icon: 'id-eventi',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [],
        committee:['A'],
        permission: ['T', 'AS']
      }
      ]
  },
  {
    path: '/project-admin',
    title: 'Progetti',
    icon: 'id-contabilita',
    class: '',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: [],
    committee:['N'],
    permission: ['A', 'C']
  },
  {
    path: '/project',
    title: 'Progetti',
    icon: 'id-contabilita',
    class: '',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: [],
    committee:['A'],
    permission: ['AS', 'C', 'S']
  },

  /*{
    path: '#',
    title: 'Progetti',
    icon: 'id-contabilita',
    class: 'has-sub',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    committee:['N','A'],
    permission: ['A', 'C','AS','S'],
    submenu: [
      {
        path: '/project-admin',
        title: 'Progetti',
        icon: 'id-contabilita',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [],
        committee:['N'],
        permission: ['A', 'C']
      },
      {
        path: '/project',
        title: 'Progetti',
        icon: 'id-contabilita',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [],
        committee:['A'],
        permission: ['AS', 'C', 'S']
      }
    ],

  },*/
  {
    path: '/discipline',
    title: 'Discipline',
    icon: 'id-discipline',
    class: '',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: [],
    committee:['N','P','G', 'R'],
    permission: ['U', 'C']
  },/*{
    path: '',
    title: 'Discipline',
    icon: 'id-discipline',
    class: 'has-sub',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    committee:['N','P','G', 'R'],
    permission: ['U', 'C'],
    submenu:[
      {
        path: '/discipline',
        title: 'Discipline',
        icon: 'id-discipline',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [],
        committee:['N','P','G', 'R'],
        permission: ['U', 'C']
      }
    ]
  },*/ {
    path: '#',
    title: 'Convenzioni',
    icon: 'id-tessera',
    class: 'has-sub',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    committee:['N', 'A'],
    permission: ['T', 'AS'],
    submenu: [
      {
        path: '/voucher',
        title: 'Voucher ASSIST',
        icon: 'id-tessera',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [],
        committee:['N', 'A'],
        permission: ['T', 'AS']
      },
      {
        path: '/assicurazione-animali',
        title: 'Cani / Cavalli',
        icon: 'id-tessera',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [],
        committee:['N'],
        permission: ['T']
      },
      {
        path: '/drivalia',
        title: 'Drivalia',
        icon: 'id-tessera',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [],
        committee:['N'],
        permission: ['T']
      },
    ],

  },

  {
    path: '#',
    title: 'Notifiche',
    icon: 'ft-bell',
    class: 'has-sub',
    badge: '',
    badgeClass: 'ng-tns-c1-0 badge badge-pill badge-danger float-right mr-1 mt-1 ng-star-inserted',
    isExternalLink: false,
    committee:['N','P','G','A'],
    permission: ['T','C','AS'],
    submenu: [
      {
        path: '/elenco-notifiche',
        title: 'Notifiche',
        icon: 'ft-bell',
        class: '',
        badge: '',
        badgeClass: 'ng-tns-c1-0 badge badge-pill badge-danger float-right mr-1 mt-1 ng-star-inserted',
        isExternalLink: false,
        submenu: [],
        committee:['N','P','G','A'],
        permission: ['T','C','AS']
      },
      {
        path: '/notifiche',
        title: 'Gestione Notifiche',
        icon: 'ft-bell',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [],
        committee:['N'],
        permission: ['U']
      },
      {
        path: '/media',
        title: 'Media',
        icon: 'id-utenti',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [],
        committee:['N'],
        permission: ['U']
      }
    ]

  },
  {
    path: '#',
    title: 'Controllo & Tutela',
    icon: 'id-verifica-off',
    class: 'has-sub',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    committee:['N'],
    permission: ['K'],
    submenu:[
      {
        path: '/servizi/affiliazioni/safe',
        title: 'Safeguarding',
        icon: 'id-verifica-off',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [],
        committee:['N'],
        permission: ['K']
      },
    ]
  },







  /*{
    path: '/servizi/tesseramento',
    title: 'Tesserati',
    icon: 'id-tesserato',
    class: '',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: [],
    committee:['A'],
    permission: ['AS', 'C', 'S']
  },{
    path: '/servizi/affiliazioni/profilo/me',
    title: 'Profilo',
    icon: 'id-verifica-off',
    class: '',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: [],
    committee:['A'],
    permission: ['AS', 'C', 'S']
  },{
    path: '/servizi/affiliazioni',
    title: 'Affiliati',
    icon: 'id-verifica-off',
    class: '',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: [],
    committee:['N','R','P','G'],
    permission: ['AS', 'C', 'S']
  },
  {
    path: '/servizi/tesseramento',
    title: 'Tesserati',
    icon: 'id-tesserato',
    class: '',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: [],
    committee:['N','R','P','G'],
    permission: ['AS', 'C', 'S']
  },

  {
    path: '/servizi/interno/interno',
    title: 'Tess Diretto',
    icon: 'id-tesserato',
    class: '',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: [],
    committee:['N','R','P'],
    permission: ['AS', 'C', 'S']
  },

  {
    path: '/albo/tecnici',
    title: 'Albo tecnici',
    icon: 'id-tecnici',
    class: '',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: [],
    committee:['N','R','P','G'],
    permission: ['T', 'C']
  },
  {
    path: '/albo/formatori',
    title: 'Albo formatori',
    icon: 'id-formatori',
    class: '',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: [],
    committee:['N','R','P','G'],
    permission: ['T', 'C']
  },
  {
    path: '/servizi/gruppi',
    title: 'Gruppi',
    icon: 'id-gruppi',
    class: '',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: [],
    committee:['N','G'],
    permission: ['S']
  },
  {
    path: '/servizi/comitati',
    title: 'Comitati',
    icon: 'id-comitati',
    class: '',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: [],
    committee:['N','R','P'],
    permission: ['S']
  },
  {
    path: '/servizi/tessere',
    title: 'Tessere',
    icon: 'id-tessera',
    class: '',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: [],
    committee:['N','P','G','A'],
    permission: ['AS', 'C', 'S']
  },
  {
    path: '/servizi/magazzino',
    title: 'Magazzino',
    icon: 'id-tessera',
    class: '',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: [],
    committee:['N','P','G','A'],
    permission: ['AS', 'C', 'S']
  },
  {
    path: '/servizi/conversioni',
    title: 'Conversioni',
    icon: 'id-conversioni',
    class: '',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: [],
    committee:['N','P','G'],
    permission: ['T', 'C']
  },
  {
    path: '/servizi/formativa',
    title: 'Att. Formative',
    icon: 'id-corsi',
    class: '',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: [],
    committee:['N','P','G','A'],
    permission: ['T', 'C','AS']
  },
  {
    path: '/servizi/didattica',
    title: 'Att. Didattiche',
    icon: 'id-corsi',
    class: '',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: [],
    committee:['N','P','G','A'],
    permission: ['T', 'C','AS']
  },
  {
    path: '/servizi/eventi',
    title: 'Att. Sportive',
    icon: 'id-eventi',
    class: '',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: [],
    committee:['N','P','G', 'R'],
    permission: ['T', 'C']
  },*/
  /*{
    path: '/contabilita',
    title: 'Contabilità',
    icon: 'id-contabilita',
    class: '',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: [],
    committee:['N','P','G'],
    permission: ['A', 'C']
  },*/
  /*
  {
    path: '/wallet',
    title: 'Wallet',
    icon: 'id-contabilita',
    class: '',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: [],
    committee:['P', 'G'],
    permission: ['A', 'C']
  },
  {
    path: '/walletadmin',
    title: 'Wallet',
    icon: 'id-contabilita',
    class: '',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: [],
    committee:['N'],
    permission: ['A', 'C']
  },
  {
    path: '/project-admin',
    title: 'Progetti',
    icon: 'id-contabilita',
    class: '',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: [],
    committee:['N'],
    permission: ['A', 'C']
  },
  {
    path: '/project',
    title: 'Progetti',
    icon: 'id-contabilita',
    class: '',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: [],
    committee:['A'],
    permission: ['AS', 'C', 'S']
  },
  {
    path: '/discipline',
    title: 'Discipline',
    icon: 'id-discipline',
    class: '',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: [],
    committee:['N','P','G', 'R'],
    permission: ['U', 'C']
  },
  {
    path: '/elenco-notifiche',
    title: 'Notifiche',
    icon: 'ft-bell',
    class: '',
    badge: '',
    badgeClass: 'ng-tns-c1-0 badge badge-pill badge-danger float-right mr-1 mt-1 ng-star-inserted',
    isExternalLink: false,
    submenu: [],
    committee:['N','P','G','A'],
    permission: ['T','C','AS']
  },
  {
    path: '/notifiche',
    title: 'Gestione Notifiche',
    icon: 'ft-bell',
    class: '',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: [],
    committee:['N'],
    permission: ['U']
  },
  {
    path: '/media',
    title: 'Media',
    icon: 'id-utenti',
    class: '',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: [],
    committee:['N'],
    permission: ['U']
  },
  {
    path: '/utenti',
    title: 'Utenti',
    icon: 'id-utenti',
    class: '',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: [],
    committee:['N'],
    permission: ['U']
  },
  {
    path: '/servizi/disabili',
    title: 'Disabili',
    icon: 'id-utenti',
    class: '',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: [],
    committee:['N'],
    permission: ['T']
  },
  {
    path: '/voucher',
    title: 'Voucher Progetto ASSIST',
    icon: 'id-tessera',
    class: '',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: [],
    committee:['N', 'A'],
    permission: ['T', 'AS']
  },
  {
    path: '/assicurazione-animali',
    title: 'Cani / Cavalli',
    icon: 'id-tessera',
    class: '',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: [],
    committee:['N'],
    permission: ['T']
  },
  {
    path: '/drivalia',
    title: 'Drivalia',
    icon: 'id-tessera',
    class: '',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: [],
    committee:['N'],
    permission: ['T']
  },
  {
    path: '/servizi/gare',
    title: 'Gare',
    icon: 'id-eventi',
    class: '',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: [],
    committee:['A'],
    permission: ['T', 'AS']
  },*/{
    path: '/dashboard',
    title: 'Dashboard',
    icon: 'id-dashboard',
    class: '',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: [],
    committee:['N','R','P','G','A'],
    permission: ['U', 'C', 'AS']
  }/*,{
    path: '/servizi/affiliazioni/safe',
    title: 'Safeguarding',
    icon: 'id-verifica-off',
    class: '',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: [],
    committee:['N'],
    permission: ['K']
  },*/
];



// WEBPACK FOOTER //
// ./src/app/shared/sidebar/sidebar-routes.config.ts